<template>
  <div class="container">
    <moduleTitle title="个人信息"></moduleTitle>
    <div class="content">
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-width="150px"
        label-position="right"
      >
        <el-form-item label="原手机号：">
          <el-input v-model="form.ysjh" :disabled="disabled"> </el-input>
        </el-form-item>
        <el-form-item prop="xsjh" label="新手机号：">
          <el-input v-model="form.xsjh"
            ><el-button slot="append">获取验证码</el-button></el-input
          >
        </el-form-item>
        <el-form-item prop="yzm" label="验证码：">
          <el-input v-model="form.yzm" @click="throttle(getCode)"></el-input>
        </el-form-item>
      </el-form>
      <el-col :offset="11"
        ><el-button @click="save()" type="primary">保存</el-button></el-col
      >
    </div>
  </div>
</template>
<style lang="scss" scoped>
.container {
  width: 80%;
  margin: 40px auto;
  .content {
    width: 70%;
    margin: 40px auto;
  }
}
</style>
<script>
import moduleTitle from "@/components/moduleTitle.vue";
import request from "@/api/personCenter.js";
export default {
  components: { moduleTitle },
  data() {
    return {
      disabled: true,
      form: { ysjh: this.$store.state.userInfo.sjhm, yzm: "", xsjh: "" },
      rules: {
        xsjh: [
          {
            required: true,
            message: "请输入新的手机号",
            trigger: "blur"
          },
          {
            type: "string",
            pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            message: "请输入有效的手机号码",
            trigger: "blur"
          }
        ],
        yzm: [{ required: true, message: "请输入验证码", trigger: "blur" }]
      }
    };
  },
  mounted() {},
  methods: {
    // 处理多次点击
    throttle(fn, params) {
      let that = this;
      if (that.onoff && fn) {
        that.onoff = false;
        if (params) {
          fn(params);
        } else {
          fn();
        }
        setTimeout(function() {
          that.onoff = true;
        }, 1500);
      } else {
        console.log("请稍后点击");
      }
    },
    getCode() {
      if (!this.form.xsjh) {
        this.$message({
          type: "error",
          message: "新手机号不能为空"
        });
        return;
      }
      const para = {
        phone: this.form.xsjh
      };
      request
        .sendCode(para)
        .then(res => {
          console.log(res); //倒计时
          this.timer = setInterval(() => {
            if (this.count > 0) {
              this.show = false;
              this.count--;
              console.log(this.count);
            } else {
              this.show = true;
              clearInterval(this.timer); // 清除定时器
              this.timer = null;
              this.count = 60;
            }
          }, 1000);
        })
        .catch(() => {});
    },
    save() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          let param = {
            yhid: this.$store.state.userInfo.yhid,
            xsjh: this.form.xsjh,
            yzm: this.form.yzm
          };
          let that = this;
          request
            .modifyGrxx(param)
            .then(function(data) {
              that.$message({
                message: "修改个人信息成功",
                type: "success",
                showClose: true
              });
              console.log("response");
              console.log(data);
            })
            .catch(function(error) {
              console.log("error");
              console.log(error);
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
